import ApiConfig from "../../Utils/Configs/apiConfig";
import AlertMessage from "../../Components/AlertMessage/AlertMessage";
import { buttonFlag } from "../../Reducer/AddInvoiceReducer";
import { type Dispatch } from "@reduxjs/toolkit";
import { mapInvoice , mapSingleInvoice, mapToUpdateInvoicePayload } from "./invoice.mapper";
import {
  GetInvoicesPayload,
  //UpdateInvoiceStagePayload,
} from "./invoice.payloads";
import { InvoiceType } from "../../Types/Invoice";
import {GetInvoicesRequestDTO } from "../../Types/DTO";
import { InvoiceFieldMap } from "./constants";
import { HistoryActionType, InvoiceHistoryEntry } from "../../Pages/Steps/3Inbox/InvoiceFormHistory/Invoiceformhistory.types";
//import {InvoiceType } from "../../Types/Invoice"
import { formatFieldValue } from "./dateFields";
import { getApplicationTypeEncryptedKey } from "../../Reducer/ApplicationTypeReducer";
interface PostInvoiceImageServiceProp {
  filePath: string;
  clientUserId: string | null;
  uploadMode: "per-file" | "per-page";
  onSuccess: () => void;
  dispatch: Dispatch;
}
export interface MergeInvoiceRequest {
  invoiceIds: number[];
  // Optional form overrides from MergeInvoicePopup
  // If user edited these in the popup, they override the first invoice's values
  type?: string;
  invoiceDate?: string;
  supplier?: string;
  documentReference?: string;
  dueDate?: string;
  category?: string;
  description?: string;
  currency?: string;
  totalAmount?: number;
  taxAmount?: number;
}

export interface MergeInvoiceResponse {
  mergedInvoiceId: number;
  sourceInvoiceIds: number[];
}

export interface UnmergeInvoiceRequest {
  mergedInvoiceId: number;
}

export interface UnmergeInvoiceResponse {
  unmergedInvoiceId: number;
  restoredInvoiceIds: number[];
}


export const PostInvoiceImageService = async ({
  filePath,
  clientUserId,
  onSuccess,
  uploadMode,
  // setDisableInvoiceButton,
  dispatch,
}: PostInvoiceImageServiceProp) => {
  const payload = {
    clientUserId: clientUserId,
    mergedImageFilePaths: filePath,
    uploadMode: uploadMode,
  };
  try {
    const encryptedKey = getApplicationTypeEncryptedKey();
    const response = await ApiConfig.getInstance().post(
      "/Invoice/UploadInvoiceImage",
      payload,
            {
        headers: encryptedKey
          ? { "X-Application-Type-Id": encryptedKey }
          : undefined,
      },
    );
    

    // alert("Invoice Uploaded Successfully");
    AlertMessage({
      text: "Invoice uploaded successfully",
      type: "success",
    });

    onSuccess();
    // setDisableInvoiceButton(false);
    localStorage.setItem("buttonStatus", false.toString());
    dispatch(buttonFlag(false));
    return response;
  } catch (message) {
    console.error(message);
  }
};
// NEW GET INVOICES WITH PAGINATION USING PARAMS OBJECT
export const GetInvoicesService_NEW = async (payload: GetInvoicesPayload) => {
  try {
    //alert("new get invoice called ")
 const response = await ApiConfig.getInstance().post(
      `/Invoice/filter/by-stage-ids`,
      payload
    );
 const data = response?.data?.data;

    return {
      Items: (data?.items || []).map(mapInvoice), // use mapper
      NextCursor: data?.nextCursor ?? null,
      HasMore: data?.hasMore ?? false,
      TotalItem: data?.totalCount ?? 0,
    };
  } catch (error) {
    console.error("Error in GetInvoicesService_NEW", error);

    return {
      Items: [],
      NextCursor: null,
      HasMore: false,
      TotalItem: 0,
    };
  }
};
export const UpdateInvoiceStageAndArchiveStatusService = async (
  payload: {
    invoiceIds: number [] | undefined;
    stageId: number | undefined | null;
    archiveStatus: string | boolean | undefined | null;
  }
) => {
  try {
    const response = await ApiConfig.getInstance().put(
  `/Invoice/UpdateInvoiceStagesV2`,payload   
    );
    console.log(
      "Response from UpdateInvoiceStageAndArchiveStatusService",
      response.data
    );
    return {
      success: true,
      data: response.data?.data ?? null,
      message: response.data?.message ?? "Invoice updated successfully",
    };
  } catch (error) {
    console.error(
      "Error in UpdateInvoiceStageAndArchiveStatusService",
      error
    );
    return {
      success: false,
      data: null,
      message: "Failed to update invoice stage or archive status",
    };
  }
};


//todo- need to remove 
//INVOICE WITH PAGINATION
export const GetInvoicesService = async (
  stageId: number,
  userId: string,
  limit?: number | 5,
  after?: string | null,
  order?: keyof typeof InvoiceFieldMap | null,
  reversed?: boolean,
) => {
  try {
const requestBody:GetInvoicesRequestDTO = {
  accountId: userId,
  stageid: stageId ?? 0,
  limit: limit ?? 50,
  ...(after && { after }),
  ...(order && { order: InvoiceFieldMap[order] }),
  ...(reversed && { reversed }),
};
//  console.log("FE key is "+order)
//  console.log("BE key is "+requestBody.order)
    const response = await ApiConfig.getInstance().post(
      `/Invoice/GetAllInvoicesWithPagination`,
      requestBody
    );

    if (!response.data || !response.data.data.items) return { Items: [], NextCursor: null, HasMore: false };

    const invoices = response.data.data.items;

    // Map invoices based on stage
const mappedInvoices =
  stageId === 2
    ? invoices.map((invoice: any) => ({
        id: invoice.invoiceId ?? "",
        userId: invoice.userId ?? "", // corrected
        adminUserId: invoice.adminUserId ?? null, // corrected
        documentUrl: invoice.documentUrl ?? null,
        documentOwner: invoice.documentOwner ?? "",
        type: invoice.type ?? "",
        invoiceDate: invoice.invoiceDate ?? "",
        supplier: invoice.supplier ?? "",
        extractedPoNumber: invoice.extractedPoNumber ?? "",
        documentReference: invoice.documentReference ?? "",
        dueDate: invoice.dueDate ?? "",
        discountAmount: invoice.discountAmount ?? null,
        category: invoice.category?.trim() ?? "",
        productOrService: invoice.productOrService?.trim() ?? "",
        user: invoice.customer ?? "",
        markAsRebillable: invoice.markAsRebillable ?? "",
        description: invoice.description ?? "",
        amount: invoice.amount ?? 0,
        currency: invoice.currency ?? "",
        totalAmount: invoice.totalAmount ?? 0,
        taxAmount: invoice.taxAmount ?? 0,
        netAmount: invoice.netAmount ?? 0,
        payment: invoice.payment ?? 0,
        paid: invoice.paid ?? 0,
        paymentMethod: invoice.paymentMethod ?? "",
        lineItems: Array.isArray(invoice.lineItems) ? invoice.lineItems : [],
        stageId: invoice.stageId ?? 0,
        isActive: invoice.isActive ?? true,
        isDelete: invoice.isDelete ?? false,
      }))
    : invoices.map((invoice: any) => ({
        id: invoice.invoiceId ?? "",
        stageId: invoice.stageId ?? 0,
        documentOwner: invoice.documentOwner ?? "",
        user: invoice.customer ?? "",
        discountAmount: invoice.discountAmount ?? null,
        description: invoice.description ?? "",
        date: invoice.invoiceDate ?? "",
        supplier: invoice.supplier ?? "",
        category: invoice.category?.trim() ?? "",
        total: invoice.totalAmount ?? 0,
        documentReference: invoice.documentReference ?? "",
        taxAmount: invoice.taxAmount ?? 0,
        type: invoice.type ?? "",
      }));


    return {
      Items: mappedInvoices,
      NextCursor: response.data.data.nextCursor ?? null,
      HasMore: response.data.data.hasMore ?? false,
      TotalItem: response.data.data.totalCount ?? 200 // Need to update this based on baackend response
    };
  } catch (error) {
    console.error("Error in Invoice Service",error);
    return { Items: [], NextCursor: null, HasMore: false };
  }
};

// ! SINGLE Invoice
export const GetInvoiceService = async (
  invoiceId: number
): Promise<InvoiceType | null> => {
  try {
    const response = await ApiConfig.getInstance().get(
      `/Invoice/GetInvoiceById/${invoiceId}`
    );  
 const data = response?.data;

    if (!data) return null;
const temp = mapSingleInvoice(data); 
return temp 
    return mapSingleInvoice(data); // clean
  } catch (error) {
    console.error("Error fetching invoice:", error);
    return null;
  }
};
//Status can be [All, Pending, Archieved]
export const PutInvoicesService = async (stageId: number, invoiceData: any) => {
   try {
    const payload = mapToUpdateInvoicePayload({
      ...invoiceData,
      stageId, // ensure stageId is used
    });
    const response = await ApiConfig.getInstance().put(
      "/Invoice/UpdateInvoice",
      payload
    );
    return {
      success: true,
      data: response.data?.data ?? null,
      message: response.data?.message ?? "Invoice updated successfully",
    };
  } catch (error :any) {
     AlertMessage({
       type: "error",
       text: "Failed to update invoice",
     });
    return {
      success: false,
      data: null,
      message: "Failed to update invoice",
    };
  }
};
//Update Invoice Stage
export const UpdateInvoiceStage = async (stageId: number, invoiceId: any) => {
  try {
    console.warn(stageId);
    console.warn(invoiceId);
    const response = await ApiConfig.getInstance().put(
      `/Invoice/UpdateInvoiceStage/${invoiceId}/${stageId}`
    );
    return response;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const DeleteInvoice = async (invoiceId: number) => {
  try {
    console.warn("Deleting Invoice:", invoiceId);
    const response = await ApiConfig.getInstance().delete(
      `/Invoice/DeleteInvoice/${invoiceId}`
    );
    AlertMessage({
      text: "Invoice deleted successfully",
      type: "success",
    });
    return response;
  } catch (error:any) {
    console.error("Delete Invoice Error:", error);
    AlertMessage({
      text: error.message || "Failed to delete invoice",
      type: "error",
    });
    return [];
  }
};


//  UPDATE FLAG (NEW)
export const UpdateInvoiceFlagService = async (
  invoiceId: number,
  isFlagged: boolean
) => {
  try {
    await ApiConfig.getInstance().put(
      `/Invoice/UpdateFlag`,
      {
        invoiceId,
        isFlagged,
      }
    );

    return { success: true };
  } catch {
    return { success: false };
  }
};
// ─── Merge API call ───────────────────────────────────────────────────────────

/// Calls POST /api/Invoice/MergeInvoices
/// Sends the selected invoice IDs + any form field overrides the user made
/// Returns the new merged invoice's ID so we can fetch and display it
export const MergeInvoicesService = async (
  request: MergeInvoiceRequest
): Promise<MergeInvoiceResponse> => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Invoice/MergeInvoices",
      request
    );
    // Backend wraps in ServiceResult envelope: { status, data, message }
    return response.data?.data ?? response.data;
  } catch (error: any) {
    console.error("Error in MergeInvoicesService", error);
    throw new Error(error?.response?.data?.message ?? "Failed to merge invoices");
  }
};

export const UnmergeInvoiceService = async (
  request: UnmergeInvoiceRequest
): Promise<UnmergeInvoiceResponse> => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Invoice/UnmergeInvoices",
      request
    );

    // TEMP DEBUG — remove after fix
    console.log("Unmerge raw response.data:", response.data);

    const data = response.data?.data ?? response.data;

    return {
      unmergedInvoiceId:  data?.unmergedInvoiceId  ?? 0,
      restoredInvoiceIds: data?.restoredInvoiceIds  ?? [],
    };
  } catch (error: any) {
    console.error("Error in UnmergeInvoiceService", error);
    throw new Error(error?.response?.data?.message ?? "Failed to unmerge invoice");
  }
};

export interface InvoiceNoteData {
  note: string;
  rowVersion: string;
}

/** Thrown when the server rejects a save because the note was changed by someone else. */
export class ConcurrentEditError extends Error {
  constructor(message = "This note has been updated by another user. Please refresh and try again.") {
    super(message);
    this.name = "ConcurrentEditError";
    Object.setPrototypeOf(this, ConcurrentEditError.prototype); 
  }
}

export const GetInvoiceNoteService = async (
  invoiceId: number
): Promise<InvoiceNoteData> => {
  try {
    const response = await ApiConfig.getInstance().get(
      `/Invoice/${invoiceId}/note`
    );
    const payload = response?.data?.data ?? response?.data ?? {};
    return {
      note: payload?.note ?? "",
      rowVersion: payload?.rowVersion ?? "",
    };
  } catch (error) {
    console.error("Error fetching invoice note:", error);
    return { note: "", rowVersion: "" };
  }
};

export const UpdateInvoiceNoteService = async (
  invoiceId: number,
  note: string,
  rowVersion: string
): Promise<InvoiceNoteData> => {
  try {
    const response = await ApiConfig.getInstance().put(`/Invoice/note`, {
      invoiceId,
      note,
      rowVersion,
    });
    console.log("RAW SUCCESS RESPONSE:", response.data);
    const payload = response.data?.data ?? response.data ?? {};
    return {
      note: payload?.note ?? note,
      rowVersion: payload?.rowVersion ?? "",
    };
  } catch (error: any) {
    const backendStatusCode = error?.response?.data?.status?.statusCode;
    const backendMessage = error?.response?.data?.message;

    if (backendStatusCode === 409) {
      throw new ConcurrentEditError(backendMessage);
    }

    console.error("Error saving invoice note:", error);
    throw new Error(backendMessage || "Failed to save note");
  }
};

interface RawHistoryEntry {
  historyId: number;
  actionType: string;
  fieldName: string | null;
  oldValue: string | number | null;
  newValue: string | number | null;
  submissionMethod: string | null;
  userDisplayName: string;
  isSystemAction: boolean;
  createdAt: string;
}

// Confirm the other keys with backend — only "FieldEdited" and "Unarchived"
// are visible in your sample, the rest are inferred from the pattern.
const ACTION_TYPE_MAP: Record<string, HistoryActionType> = {
  Submitted: "SUBMITTED",
  FieldEdited: "FIELD_EDITED",
  PublishedManual: "PUBLISHED_MANUAL",
  PublishedAuto: "PUBLISHED_AUTO",
  Archived: "ARCHIVED",
  UnArchived: "UNARCHIVED",
  Viewed: "VIEWED",
  PageSplit: "PAGE_SPLIT",
  Merged: "MERGED",
  Unmerged: "UNMERGED",
};

const mapHistoryEntry = (raw: RawHistoryEntry): InvoiceHistoryEntry => ({
  id: raw.historyId,
  actionType: ACTION_TYPE_MAP[raw.actionType] ?? (raw.actionType as HistoryActionType),
  performedBy: raw.isSystemAction ? "System" : raw.userDisplayName,
  performedAt: raw.createdAt,
  method: raw.submissionMethod ?? undefined,
  fieldChange:
   raw.actionType === "FieldEdited" && raw.fieldName
      ? {
          fieldName: raw.fieldName,
          oldValue: formatFieldValue(raw.fieldName, raw.oldValue),
          newValue: formatFieldValue(raw.fieldName, raw.newValue),
        }
      : undefined,

  pageSplit:
    raw.actionType === "PageSplit" && raw.fieldName
      ? {
          sourceFileName: raw.fieldName,
          pageCount: raw.newValue ?? "—",
        }
      : undefined,

  mergeInfo:
  raw.actionType === "Merged" || raw.actionType === "Unmerged"
    ? {
        invoiceIds: String(
          raw.fieldName === "SourceInvoiceIds" || raw.fieldName === "RestoredInvoiceIds"
            ? (raw.actionType === "Merged" ? raw.newValue : raw.oldValue)
            : (raw.actionType === "Merged" ? raw.newValue : raw.oldValue) // single ID case
        )
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean),
        // new — tells the UI which sentence to render
        perspective:
          raw.fieldName === "MergedIntoInvoiceId" || raw.fieldName === "UnmergedFromInvoiceId"
            ? "source"
            : "merged",
      }
    : undefined,
});





export const GetInvoiceHistoryService = async (
  invoiceId: number,
  entityType: string = "Invoice"
): Promise<InvoiceHistoryEntry[]> => {
  try {
    const response = await ApiConfig.getInstance().get(
      `/DocumentHistory/${entityType}/${invoiceId}`
    );
    const rawEntries = response?.data?.data ?? [];
    return Array.isArray(rawEntries) ? rawEntries.map(mapHistoryEntry) : [];
  } catch (error) {
    console.error("Error fetching invoice history:", error);
    return [];
  }
};

export interface GetInvoicesByIdsRequest {
  invoiceIds: number[];
}
 
// Mirrors InvoiceMobileResponseDTO exactly (PascalCase, as returned by the API)
export interface InvoiceMobileResponseDTO {
  InvoiceId: number;
  UserId?: string;
  AdminUserId?: string;
  DocumentUrl?: string;
  DocumentOwner?: string;
  Type?: string;
  InvoiceDate?: string;
  Supplier?: string;
  ExtractedPoNumber?: string;
  DocumentReference?: string;
  DueDate?: string;
  Category?: string;
  ProductOrService?: string;
  Customer?: string;
  MarkAsRebillable?: string;
  Description?: string;
  Amount?: number;
  Currency?: string;
  DiscountAmount?: number;
  TotalAmount?: number;
  TaxAmount?: number;
  NetAmount?: number;
  Payment?: number;
  Paid?: string;
  PaymentMethod?: string;
  LineItems?: string[];
  StageId?: number;
  IsActive?: boolean;
  IsDelete?: boolean;
  CreatedDate?: string;
}
 
export const GetInvoicesByIdsService = async (
  request: GetInvoicesByIdsRequest
): Promise<InvoiceMobileResponseDTO[]> => {
  try {
    const response = await ApiConfig.getInstance().post(
      "/Invoice/GetInvoicesByIds",
      { invoiceIds: request.invoiceIds }
    );
    // Backend wraps in ServiceResult envelope: { status, data, message }
    const data = response.data?.data ?? response.data;
    return Array.isArray(data) ? data : [];
  } catch (error: any) {
    console.error("Error in GetInvoicesByIdsService", error);
    throw new Error(error?.response?.data?.message ?? "Failed to fetch invoice details");
  }
};